/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Often, yes. A longer test smooths out bursts and fatigue, giving a more representative average typing speed than a very short one.`)
};

const es_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A menudo, sí. Un test más largo suaviza los arranques rápidos y la fatiga, dando una velocidad promedio más representativa que un test muy corto.`)
};

const de_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oft ja. Ein längerer Test gleicht kurze Spitzen und Ermüdung aus und liefert dadurch eine repräsentativere durchschnittliche Tippgeschwindigkeit als ein sehr kurzer Test.`)
};

const nl_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaak wel. Een langere test vlakt pieken en vermoeidheid uit, wat een representatievere gemiddelde typsnelheid oplevert dan een zeer korte test.`)
};

const fr_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souvent, oui. Un test plus long lisse les pics et la fatigue, donnant une vitesse de frappe moyenne plus représentative qu'un test très court.`)
};

const it_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesso sì. Un test più lungo attenua gli scatti iniziali e la stanchezza, dando una velocità di digitazione media più rappresentativa rispetto a un test molto breve.`)
};

const pt_br2_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na maioria das vezes, sim. Um teste mais longo suaviza picos e o cansaço, dando uma velocidade média de digitação mais representativa do que um teste muito curto.`)
};

const pt_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na maioria das vezes, sim. Um teste mais longo suaviza os picos e o cansaço, dando uma velocidade média de escrita mais representativa do que um teste muito curto.`)
};

const ja_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くの場合、はい。テストが長いほど、瞬間的な速さや疲労による変動が均され、短いテストよりも実際の平均タイピング速度に近い数値が得られます。`)
};

const zh_typing_variant_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常是的。更长的测试能平滑短暂爆发和疲劳的影响，比非常短的测试更能反映出具有代表性的平均打字速度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_faq2_a", locale)
	if (locale === "en") return en_typing_variant_faq2_a(inputs)
	if (locale === "es") return es_typing_variant_faq2_a(inputs)
	if (locale === "de") return de_typing_variant_faq2_a(inputs)
	if (locale === "nl") return nl_typing_variant_faq2_a(inputs)
	if (locale === "fr") return fr_typing_variant_faq2_a(inputs)
	if (locale === "it") return it_typing_variant_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_faq2_a(inputs)
	if (locale === "pt") return pt_typing_variant_faq2_a(inputs)
	if (locale === "ja") return ja_typing_variant_faq2_a(inputs)
	return zh_typing_variant_faq2_a(inputs)
};